import { render, staticRenderFns } from "./ValidateFormPage.vue?vue&type=template&id=2bfad68c&"
import script from "./ValidateFormPage.vue?vue&type=script&lang=js&"
export * from "./ValidateFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports